import type { ExpenseCategory, ExpenseStatus } from '@/lib/types';

/* Adapters bridging the Cafe Receipts design tokens and the domain types.
   The domain types in lib/types.ts are the source of truth; we adapt at the edges. */

/* ===== Status ===== */
// The design CSS uses the class name "donated"; the domain uses "donation".
export type DesignStatus = 'pending' | 'reimbursed' | 'donated';

export function toDesignStatus(status: ExpenseStatus): DesignStatus {
  return status === 'donation' ? 'donated' : status;
}

export function fromDesignStatus(status: DesignStatus): ExpenseStatus {
  return status === 'donated' ? 'donation' : status;
}

/* ===== Role ===== */
// The design uses "member"; the domain uses "user" (admin matches).
export type DesignRole = 'admin' | 'member';

export function toDesignRole(role: string | null | undefined): DesignRole {
  return role === 'admin' ? 'admin' : 'member';
}

export function fromDesignRole(role: DesignRole): string {
  return role === 'admin' ? 'admin' : 'user';
}

/* ===== Category colors ===== */
// Maps each domain ExpenseCategory to the design's chart/chip color.
export const CATEGORY_COLORS: Record<ExpenseCategory, string> = {
  beans: 'oklch(0.42 0.06 50)',
  milk: 'oklch(0.85 0.04 75)',
  syrups: 'oklch(0.62 0.14 25)',
  beverages: 'oklch(0.55 0.13 145)',
  cups: 'oklch(0.70 0.10 90)',
  ice: 'oklch(0.78 0.07 220)',
  towels: 'oklch(0.65 0.05 60)',
  equipment: 'oklch(0.45 0.04 260)',
  cleaning: 'oklch(0.60 0.09 200)',
  food: 'oklch(0.55 0.11 35)',
  other: 'oklch(0.55 0.02 70)',
};

export function categoryColor(category: ExpenseCategory): string {
  return CATEGORY_COLORS[category] ?? CATEGORY_COLORS.other;
}
